import { Badge, Flex } from 'antd';

import { usePendingOpenReportMessages } from '@/store';

export const PendingIncidentsBadge = () => {
  const { isLoading, pendingReports } = usePendingOpenReportMessages();

  if (isLoading) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={pendingReports ?? 0} />
    </Flex>
  );
};
